<template>
  <div class="modal fade wt-bulk-disclosure-overlay" id="wt-bulk-disclosure-overlay" tabindex="-1" aria-labelledby="wt-bulk-disclosure-overlay" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="wt-bulk-disclosure-overlay-label">Universal TCPA Dislosure</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="exit"></button>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row pending-bulk-submit">
              <div class="col-4">
                  <img class="school-logo" :src="offer.logoURL" v-if="offer.logoURL" />
              </div>
              <div class="col-8 school-title">
                {{offer.name}}<br /><br />
                <div v-if="campusNameFound() !== undefined">
                  Campus Preference: {{campusNameFound()}}<br />
                </div>
                <div v-if="programNameFound() !== undefined">
                  Program of Interest: {{programNameFound()}}
                </div>
              </div>
            </div>
            <div class="row">
              <hr />
            </div>
            <div class="row">
              <div class="col-12 bulk-tcpa-required">Must Read:</div>
            </div>
            <div class="row">
              <div class="col-12 bulk-tcpa" v-html="mappedBulkTcpa"></div>
            </div>
            <div class="wt-header row" v-show="submitStep === 3">
              <div class="col-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                </svg>
              </div>
              <div class="col-8"><div class="row justify-content-center wt-title"><div class="col-auto">Warm Transfer Details</div></div></div>
              <div class="col-2 text-end">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                </svg>
              </div>
            </div>
            <div class="row wt-questions"  v-show="submitStep === 3">
              <slot></slot>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <PlayTCPAButton v-show="hasPlayTcpa" @submit="submitStep2" websocket-name="lhwt" :opened="open" :has-play-tcpa="hasPlayTcpa" />

          <button class="btn btn-primary" @click="submitStep1" v-show="showFirstSubmit" :disabled="loadingQuestions">Submit!</button>
          <button class="btn btn-success" @click="submitStep2" v-show="submitStep === 2">
            <span class="fw-bold">></span> If TCPA is Confirmed,<br />
            <span class="fw-bold">CLICK HERE</span>
            </button>
          <button class="btn btn-success" @click="submitOffers" v-show="submitStep === 3">
            <span class="fw-bold">></span> If Script has been read,<br />
            <span class="fw-bold">CLICK HERE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import PlayTCPAButton from './PlayTCPAButton.vue'
export default {
  name: 'WtBulkSubmitOverlay',
  components: { PlayTCPAButton },
  props: ['open', 'loadingQuestions', 'offer'],
  emits: ['submitOffers', 'exitNoSubmit'],
  data () {
    return {
      submitStep: 1,
      campusName: undefined,
      programName: undefined
    }
  },
  mounted () {
    this.initModal()
  },
  methods: {
    ...mapMutations({
      removeAllPendingLeadRequest: 'consumer/leadRequests/removeAllPendingLeadRequest'
    }),
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]

      var loop_section = new RegExp('(?<=__list_external_offer_names__)(.*)(?=__/list_external_offer_names__)')
      if (text.match(loop_section) !== undefined) {
        var loop_text = ''
        this.offerNamesString.split(',').forEach((name, idx) => {
          if (text.match(loop_section) !== null) {
            loop_text += text.match(loop_section)[0].replace(new RegExp('__display_external_offer_name__', 'g'), '<label data-leadid_tcpa> <input type="checkbox" id="leadid_tcpa_brandname_' + idx + '" />' + name + '</label>' ?? '') + '<br/>'
          }
        })
        text = text.replace(new RegExp('__list_external_offer_names__.*__/list_external_offer_names__', 'g'), loop_text)
      }
      text = text.replace(new RegExp('__external_offer_names__', 'g'), this.offerNamesString)

      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }

      return '<label><input type="hidden" id="leadid_tcpa_disclosure"/>' + text + '</label>'
    },
    campusNameFound () {
      return this.campusName
    },
    programNameFound () {
      return this.programName
    },
    async initModal () {
      await new Promise((resolve) => setTimeout(resolve, 100))
      this.modal = new bootstrap.Modal(document.getElementById('wt-bulk-disclosure-overlay'), { backdrop: 'static', keyboard: false })
    },
    openModal () {
      if (this.pendingLeadRequests.length !== 0) {
        var campus = this.pendingLeadRequests[0].offer.campuses.find(campus => campus.id === this.pendingLeadRequests[0].leadRequest.raw_request.lead_education.campus_id)
        this.campusName = campus === undefined ? undefined : campus.name

        var program = this.pendingLeadRequests[0].offer.programs.find(program => program.id === this.pendingLeadRequests[0].leadRequest.raw_request.lead_education.program_id)
        this.programName = program === undefined ? undefined : program.name
        this.removeAllPendingLeadRequest()
      }

      this.modal.toggle()
      var backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops.forEach((backdrop) => {
        backdrop.classList.add('bulk-submit')
      })
    },
    closeModal () {
      this.submitStep = 1
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
        backdrop.classList.remove('bulk-submit')
      })
      this.modal.toggle()
    },
    submitStep1 () {
      if (this.multiConsentValid()) {
        this.submitStep = 2
      }
    },
    submitStep2 () {
      this.submitStep = 3
    },
    submitOffers () {
      this.$emit('submitOffers')
    },
    exit () {
      this.$emit('exitNoSubmit')
    },
    multiConsentValid () {
      let valid = true
      this.$el.querySelectorAll('label[data-leadid_tcpa] input').forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.parentNode.classList.add('info-error')
          valid = false
        } else {
          checkbox.parentNode.classList.remove('info-error')
        }
      })
      return valid
    }
  },
  computed: {
    offerNamesString () {
      return this.offer.name
    },
    showFirstSubmit () {
      return this.submitStep === 1 && !this.hasPlayTcpa
    },
    mappedBulkTcpa () {
      return this.mapText(this.bulkTcpa)
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      bulkTcpa: state => state.consumer.bulkTcpa,
      pendingLeadRequests: state => state.consumer.leadRequests.pendingLeadRequests
    }),
    ...mapGetters({
      hasDisplayedType: 'consumer/hasDisplayedOverlayDisclosure',
      hasPlayTcpa: 'consumer/hasPlayTcpa',
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  watch: {
    open (val) {
      if (val) {
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  }
}
</script>

<style lang="scss">
.disclosure.modal-backdrop.show {
  background-color: black;
  opacity: 0.85;
}
</style>
<style lang="scss" scoped>
.school-logo {
  max-width: 100%;
}
.school-title {
  padding-top: 5px;
  padding-bottom: 15px;
}
.bulk-tcpa-required {
  color: gray;
  font-size: 12px;
  padding-bottom: 5px;
}
.wt-header {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: #6f6f6f solid 1px;
  border-bottom: #6f6f6f solid 1px;
}
.wt-header .bi-arrow-down {
  height: 45px;
}
.wt-title {
  font-size: 18px;
  font-weight: 500;
  padding-top: 10px;
}
.info-error {
  color: red;
}
</style>
